import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  icon: LucideIcon;
  children?: ReactNode;
}

export const PageHeader = ({
  title,
  icon: Icon,
  children,
}: PageHeaderProps) => {
  return (
    <>
      {/* Gradient banner */}
      <div className="h-24 bg-gradient-to-r from-brand-gradient-start via-brand-gradient-mid to-brand-gradient-end md:h-28 rtl:bg-gradient-to-l" />

      {/* Title card overlapping the gradient */}
      <div className="mx-4 -mt-[70px] sm:mx-6 lg:mx-8">
        <div className="mx-auto max-w-[86rem] rounded-xl border border-gray-200 bg-white px-5 shadow-sm">
          <div className="flex h-[88px] flex-col justify-center gap-2 md:flex-row md:items-center md:justify-between">
            <div className="flex shrink-0 items-center gap-2.5">
              <div className="flex h-[55px] w-[55px] items-center justify-center rounded-lg bg-gradient-to-br from-brand-gradient-mid to-brand-gradient-end">
                <Icon className="h-[33px] w-[33px] text-white" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            </div>
            {children && (
              <div className="flex flex-col gap-1.5 sm:flex-row sm:items-center">
                {children}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
